import { z } from 'zod'
import { Model } from './architecture'

export const ImageSizeValidation = z.object({
  width: z.number({ required_error: '[ImageSize] width is required' }),
  height: z.number({ required_error: '[ImageSize] height is required' }),
})

export class ImageSize extends Model {
  static create({ width, height }: z.infer<typeof ImageSizeValidation>) {
    ImageSizeValidation.parse({ width, height })
    return new ImageSize(width, height)
  }

  constructor(
    private readonly _width: number,
    private readonly _height: number
  ) {
    super()
  }

  get width() { return this._width } // prettier-ignore

  get height() { return this._height } // prettier-ignore

  toJSON() {
    return {
      width: this._width,
      height: this._height,
    }
  }
}
